var map = {
	"./79-plex-imc-type-1-diabetes-isletimmune-interface-banner.webp": 2160,
	"./amyloid-formation-in-type-2-diabetes-t2d-banner.webp": 220,
	"./collection-card-all-banner.webp": 4991,
	"./cystic-fibrosis-related-diabetes-cfrd-banner.webp": 2741,
	"./early-stage-type-2-diabetes-banner.webp": 1768,
	"./exeter-archival-diabetes-biobank-eadb-banner.webp": 708,
	"./exocrine-pancreas-in-type-1-diabetes-banner.webp": 620,
	"./exocrine-pancreas-pathophysiology-banner.webp": 7347,
	"./human-pancreas-analysis-program-hpap-banner.webp": 5673,
	"./human-pancreas-development-banner.webp": 4527,
	"./image-formats-suite-banner.webp": 4373,
	"./integrated-islet-distribution-program-iidp-banner.webp": 5460,
	"./neonatal-development--early-life-pancreas-handel-p-banner.webp": 9202,
	"./npod-case-6362-banner.webp": 9476,
	"./pediatric-immune-tissue-development-handel-i-banner.webp": 7496,
	"./single-cell-omics-datasets-banner.webp": 3086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4968;